<script setup lang="ts">
const { t } = useI18n()

const title = computed(() => t('layouts.title', [t('reset_password.page.title')]))

useSeoMeta({
  title,
  ogTitle: title,
})
</script>

<template>
  <div class="min-h-full flex flex-col justify-center px-4 py-12 lg:px-8 sm:px-6">
    <div class="mt-8 sm:mx-auto sm:max-w-md sm:w-full">
      <UiCard class="border-none shadow-none">
        <UiCardHeader>
          <UiCardTitle>
            {{ t('reset_password.page.title') }}
          </UiCardTitle>
          <UiCardDescription>
            {{ t('reset_password.page.description') }}
          </UiCardDescription>
        </UiCardHeader>

        <UiCardContent>
          <ResetPasswordForm class="pt-6 space-y-4" />
        </UiCardContent>
      </UiCard>
    </div>
  </div>
</template>
